function resolveApiBase() {
  //URL para produccion
  //const apiUrl = `http://alejandromorales-001-site1.rtempurl.com/api`;
  const apiUrl = `https://capsamex-trains.lat/api`;

  //URL para backup de produccion
  //const apiUrl = `http://alejandromorales-001-site4.rtempurl.com/api`;

  //URL para desarrollo
  //const apiUrl = `https://alejandromorales-001-site6.rtempurl.com/api`;

  //URL para local hosting
  //const apiUrl = `http://localhost:7023/api`;
  // console.log('API Base URL:', apiUrl);
  return apiUrl;
}

export const API_BASE = resolveApiBase();